import React, {useState} from 'react'

import ImageDrawModal from "../canvas/ImageDrawModal";
import ImageDrawCard from "../canvas/ImageDrawCard";

import thumb14 from '../images/thumb_14.jpg';
import thumb15 from '../images/thumb_15.jpg';
import thumb16 from '../images/thumb_16.jpg';

import img14 from '../images/14.png';
import img15 from '../images/15.png';
import img16 from '../images/16.png';

import "./modal.css";

export default function Cornea(){
    const [show,setShow] = useState(false);
    const [title,setTitle] = useState("Eye Lids");
    const [showImage,setShowImage] = useState(img14);
 
    const handleShow = (subtitle,imagename)=>{
         setTitle(subtitle)
         setShowImage(imagename)
         setShow(true)
    }
    const cards = [
        { title: "Cornea/Sclera - Episcleritis", thumb: thumb14, image: img14 },
        { title: "Cornea/Sclera - Neovascularization", thumb: thumb15, image: img15 },
        { title: "Cornea/Sclera - Scleritis", thumb: thumb16, image: img16 },
    ]
    return(
        <>
            <div className="card shadow-sm border-0 mb-4">
                <div className="card-body py-4">
                    {/* Heading */}
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h3 className="h5 fw-bold mb-0">Cornea/Sclera</h3>
                    </div>

                    {/* Gallery */}
                    <div className="row g-4 row-cols-2 row-cols-md-3 row-cols-lg-5">
                        {cards.map((c, i) => (
                            <ImageDrawCard
                                key={i}
                                title={c.title}
                                thumb={c.thumb}
                                image={c.image}
                                onClick={handleShow}
                            />
                        ))}

                    </div>
                </div>
            </div>
            {/* Reusable modal */}
            {showImage && (
                <ImageDrawModal
                    show={show}
                    title={title}
                    image={showImage}
                    onClose={() => setShow(false)}
                />
            )}
        </>
    )
}